app.MenuCoverPromoList = app.AbstractCollection.extend({
  model: app.MenuCoverPromo,

  url() {
    return '/api/v2/menu-cover-promos';
  },
});
